import { VuCommunicationService } from './vu-communication.service';
import { Injectable } from '@angular/core';
import { IVuConnection } from './connection/vu-connection.interfaces';

@Injectable()
export class VuLoggingService {
  private queue: string[] = [];
  private queueLimit = 1000;
  private sending: boolean = false;
  private vuConnection: IVuConnection;

  constructor(
    private vuCommunicationService: VuCommunicationService,
  ) {
    this.vuConnection = vuCommunicationService.vuConnection;
    this.vuConnection.eventConnectionChanged.subscribe((connected: boolean) => this.sendAllMessages());
    this.sendAllMessages();
  }

  writeLogMessage(message: string) {
    if (this.vuConnection && this.vuConnection.isConneсted) {
      this.appendToQueue(message);
      if (!this.sending) {
        this.sendAllMessages();
      }
    } else {
      this.appendToQueue(message);
    }
  }

  private appendToQueue(message: string) {
    if (this.queue.length >= this.queueLimit) {
      this.queue.shift();
    }
    this.queue.push(message);
  }

  private sendAllMessages() {
    if (!this.queue.length ||
      !this.vuConnection.isConneсted) {
      return;
    }
    let messageClone = this.queue;
    this.queue = [];
    this.safeWriteLogMessage(messageClone);
  }

  private safeWriteLogMessage(messages: string[]) {
    if (messages == null || !messages.length) {
      return;
    }

    let scope = this;

    scope.sending = true;
    try {
      this.vuConnection.writeLogMessages(messages)
        .then(() => {
          scope.sending = false;
          scope.sendAllMessages();
        })
        .catch(() => {
          scope.queue.unshift(...messages);
          scope.sending = false;
        });
    } catch (e) {
      scope.sending = false;
    }
  }
}
